import {
    useChannelDetails,
    useUserDetails,
} from '../../../hooks/ninchat'
import {MenubarNameProps} from './types'
import MenubarNameView from './MenubarNameView'
import {NinchatProperties} from '../../../api/types'
import React from 'react'

const ChannelMenubarName = ({
    isChannelSidebarOpen,
    onToggleChannelSidebar,
    channelId,
}: Omit<MenubarNameProps, 'chat'> & {channelId: NinchatProperties.ChannelID}): React.ReactElement => {
    const channelDetails = useChannelDetails({channelId})
    return (
        <MenubarNameView
            connected={channelDetails.connected}
            highlight={channelDetails.channelStatus === 'highlight'}
            idle={Boolean(channelDetails.idle)}
            isChannelSidebarOpen={isChannelSidebarOpen}
            name={channelDetails.name}
            onToggleChannelSidebar={onToggleChannelSidebar}
            src={channelDetails.iconurl}
            unread={channelDetails.channelStatus === 'unread'}
        />)
}

const DialogueMenubarName = ({
    isChannelSidebarOpen,
    onToggleChannelSidebar,
    dialogueId,
}: Omit<MenubarNameProps, 'chat'> & {dialogueId: NinchatProperties.DialogueID}): React.ReactElement => {
    const userDetails = useUserDetails({userId: dialogueId})

    return (
        <MenubarNameView
            connected={userDetails.connected}
            highlight={userDetails.dialogueStatus === 'highlight'}
            idle={Boolean(userDetails.idle)}
            isChannelSidebarOpen={isChannelSidebarOpen}
            name={userDetails.name}
            onToggleChannelSidebar={onToggleChannelSidebar}
            src={userDetails.iconurl}
            unread={userDetails.dialogueStatus === 'unread'}
        />)
}


const MenubarName = (props: MenubarNameProps): React.ReactElement => {
    const {
        chat,
        isChannelSidebarOpen,
        onToggleChannelSidebar,
    } = props


    const isChannel = Boolean(chat.channel_id)

    return (
        isChannel ?
            <ChannelMenubarName
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                channelId={chat.channel_id!}
                isChannelSidebarOpen={isChannelSidebarOpen}
                onToggleChannelSidebar={onToggleChannelSidebar}
            /> :
            <DialogueMenubarName
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dialogueId={chat.user_id!}
                isChannelSidebarOpen={isChannelSidebarOpen}
                onToggleChannelSidebar={onToggleChannelSidebar}
            />
    )
}


export default MenubarName
